<div class="flex flex-col max-h-[80vh] overflow-y-auto mt-4">
  @if(optionResource.isLoading()) {
    <div class="flex flex-row items-center pt-4 pb-4 pl-3 pr-3">
      <div class="flex items-center justify-center mr-3 w-10 h-10 rounded skeleton">
      </div>
      <span class="w-full skeleton"></span>
    </div>
  } @else if (optionResource.error()) {
    <div class="w-full flex flex-row justify-center items-center p-4">
      <soft-icon
        class="mr-4 text-error-300 fa-2x"
        name="fa-regular fa-file-circle-exclamation"
      ></soft-icon>
      <div class="flex flex-col">
        <span class="text-error-400">
          Fehler beim Laden der Optionen.
        </span>
      </div>
    </div>
  } @else {
    @for (option of modalOptions(); track option; let first = $first) {
      <div
        [class.border-t]="!first"
        [class]="option?.class ?? ''"
        (click)="onClick(option)"
        class="flex flex-row items-center pt-4 pb-4 pl-3 pr-3"
        [ngClass]="{
        'cursor-pointer hover:bg-hover': !option.disabled,
        'cursor-not-allowed text-lighter': option.disabled,
      }"
      >
        @if (option.icon) {
          <div class="flex items-center justify-center mr-3 w-10 h-10">
            <i [ngClass]="option?.icon"></i>
          </div>
        }
        @if (option.label) {
          <span [ngClass]="option.disabled ? 'text-lighter' : 'soft-text'">{{
              option?.label
            }}</span>
        }
        @if (optionTemplate(); as template) {
          <ng-container
            *ngTemplateOutlet="template; context: { $implicit: option.value }"
          ></ng-container>
        }
        @if (optionComponent(); as component){
          <ng-container
            *ngComponentOutlet="component; inputs: {value: option.value}"
          ></ng-container>
        }
      </div>
    } @empty {
      <div class="w-full">
        <div class="w-full flex flex-row justify-center items-center p-4">
          <soft-icon
            class="mr-4 text-lighter"
            name="fa-regular fa-file-circle-info fa-2x"
          ></soft-icon>
          <span class="text-light">
          Es sind keine Optionen vorhanden.
          </span>
        </div>
      </div>
    }
  }
</div>
